import { AutoDisableableDto, type AutoDisableableInterface } from '@zaoblako/shared/common/dtos/auto-disableable.dto';
import { MailingTemplateBaseFormDto, type MailingTemplateBaseFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-template-base-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';

/** Mailing template create and update APIs request body - DTO signature */
export interface MailingTemplateFormInterface extends AutoDisableableInterface, MailingTemplateBaseFormInterface {}

/** Mailing template create and update APIs request body - DTO schema */
export const MailingTemplateFormDto = SerdeDtoClass.union<MailingTemplateFormInterface>(NotificationDtoKeysEnum.MAILING_TEMPLATE_FORM_DTO, [
  AutoDisableableDto,
  MailingTemplateBaseFormDto,
]);
